/**
 * Convert given string value to a
 * @param valueOrNull
 * @param type
 */
export function converteValueToType(valueOrNull, type = 'string') {
    if (type === 'number') {
        if (valueOrNull === null || valueOrNull === undefined) {
            return 0;
        }
        const intVal = parseInt(valueOrNull, 10);
        if (isNaN(intVal)) {
            throw new Error(`Cannot parse "${valueOrNull}" as a number`);
        }
        return intVal;
    }
    else if (type === 'float') {
        if (valueOrNull === null || valueOrNull === undefined) {
            return 0;
        }
        const intVal = parseFloat(valueOrNull);
        if (isNaN(intVal)) {
            throw new Error(`Cannot parse "${valueOrNull}" as a float`);
        }
        return intVal;
    }
    else if (type === 'string') {
        return (valueOrNull || '');
    }
    else if (type === 'boolean') {
        return (valueOrNull !== '0' &&
            valueOrNull !== 'false' &&
            Boolean(valueOrNull));
    }
    else {
        throw new Error(`Illegal value type "${type}"`);
    }
}
